export enum ActionConstant {
	GET_STATUS = 'FILE://USER/GET_STATUS',
	CLEAR_STATUS = 'FILE://USER/CLEAR_STATUS',
	GET_PROJECTS = 'FILE://USER/GET_PROJECTS',
	CLEAR_PROJECTS = 'FILE://USER/CLEAR_PROJECTS',
	GET_SEARCH_PROJECTS = 'FILE://USER/GET_SEARCH_PROJECTS',
	CLEAR_SEARCH_PROJECTS = 'FILE://USER/CLEAR_SEARCH_PROJECTS',
	GET_SEARCHHISTORY = 'FILE://USER/GET_SEARCHHISTORY',
	CLEAR_SEARCHHISTORY = 'FILE://USER/CLEAR_SEARCHHISTORY',
	// GET_SAVED_SEARCHISTORY = 'FILE://USER/GET_SAVED_SEARCH'
}

export interface GetStatusType {
	type: ActionConstant.GET_STATUS;
	status: number;
}

export interface ClearStatusType {
	type: ActionConstant.CLEAR_STATUS;
}
export interface Lists {
	type: ActionConstant.GET_PROJECTS;
	count: number;
	rows: [];
}
export interface ProjectSearchLists {
	type: ActionConstant.GET_SEARCH_PROJECTS;
	count: number;
	rows: [];
}
export interface SearchLists {
	type: ActionConstant.GET_SEARCHHISTORY;
	searchHistory: [];
}
export interface GetListType {
	type: ActionConstant.GET_PROJECTS;
	data: Lists;
}
export interface GetProjectSearchType {
	type: ActionConstant.GET_SEARCH_PROJECTS;
	data: ProjectSearchLists;
}
export interface ClearListType {
	type: ActionConstant.CLEAR_PROJECTS;
}
export interface ClearProjectSearchType {
	type: ActionConstant.CLEAR_SEARCH_PROJECTS;
}

export interface GetSearchHistoryType {
	type: ActionConstant.GET_SEARCHHISTORY;
	data: SearchLists;
}
export interface ClearSearchHistoryType {
	type: ActionConstant.CLEAR_SEARCHHISTORY;
}

export type ActionType =
	| GetStatusType
	| ClearStatusType
	| GetListType
	| ClearListType
	| GetSearchHistoryType
	| ClearSearchHistoryType
	| GetProjectSearchType
	| ClearProjectSearchType;

export interface InitialState {
	statusCode: number;
	projectdetailsFetching: boolean;
	searchhistoryFetching: boolean;
	projectdetails: [];
	searchhistory: [];
	count: number;
	projectsearch: [];
	projectsearchcount: number;
	projectsearchFetching: boolean;
}
